import { render, staticRenderFns } from "./money_risk.vue?vue&type=template&id=74545ac6&scoped=true"
import script from "./money_risk.vue?vue&type=script&lang=js"
export * from "./money_risk.vue?vue&type=script&lang=js"
import style0 from "./money_risk.vue?vue&type=style&index=0&id=74545ac6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74545ac6",
  null
  
)

export default component.exports